export default function() {
  var nodes = [];
  this.each(function(node) {
    nodes.push(node);
  });
  return nodes;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-hierarchy/src/hierarchy/descendants.js
// module id = 313
// module chunks = 0 1 2 3 4